import { useEffect, useMemo, useState } from 'react';
import { discardWrapper, videoWrapperFactory } from '../videoWrapperFactory';
/**
 * @returns A video wrapper generated from the video data.
 */
export const useVideoWrapperFactory = (props) => {
    const { video, key, autoplay, playsInline, enabled = true, preferredCDNs, } = props;
    const [wrapper, setWrapper] = useState();
    const composedKey = useMemo(() => `${key}-${video?.encoded_id}`, [key, video?.encoded_id]);
    useEffect(() => {
        if (video && enabled) {
            videoWrapperFactory(video, {
                key: composedKey,
                autoplay,
                playsInline,
                preferredCDNs,
            }).then(setWrapper);
        }
    }, [autoplay, composedKey, playsInline, video, enabled, preferredCDNs]);
    useEffect(() => {
        return () => {
            discardWrapper(composedKey);
        };
    }, [composedKey]);
    return wrapper;
};
